<span [class]="tagClass()" [style.--bz-tag-bg]="color()" [style.--bz-tag-fg]="foreground()">
  <ng-content />
</span>
